import React, { useState, useEffect } from "react";
import { FormGroup, FormInput, Row, Col, Alert, Badge } from "shards-react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import Layout from "shared/container/LayoutAdmin";
import dayjs from "dayjs";
import { Loading, KeyinAllTable } from "views/PowerbiSetting/components";

const RowData = styled(Row)`
  margin-top: 10px;
  border-top: 1px solid #e1e5eb;
  padding-top: 20px;
`;

const showNotify = (message, type) => {
  switch (type) {
    case "success":
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "error":
      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "warn":
      toast.warn(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    case "info":
      toast.info(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
      break;
    default:
      toast.success(message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
  }
};

const PowerbiSettingDetail = (props) => {
  let { id, indicatorsId } = useParams();
  const { token } = useToken();
  const [PowerbiData, setPowerbiData] = useState(null);
  const [loading, setLoading] = useState(true);

  const formatDate = (date) => {
    const split = date
      .replace("T", " ")
      .replace(".000Z", "")
      .split(" ");
    return `${dayjs(split[0]).format("DD/MM/YYYY")} ${split[1]}.`;
  };

  const tableTabMasterId = [
    5,
    15,
    16,
    22,
    32,
    37,
    38,
    39,
    64,
    67,
    72,
    93,
    98,
    99,
    108,
    109,
  ];

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = (dataImport) => {
    setLoading(true);
    var data = JSON.stringify({
      indicatorsDatasetSettingId:
        PowerbiData != null ? PowerbiData.indicatorsDatasetSettingId : "",
      yearId: PowerbiData != null ? PowerbiData.yearId[0] : "",
      agencyId: PowerbiData != null ? PowerbiData.agencyTypeId : "",
      tableTabSettingId:
        PowerbiData != null ? PowerbiData.tableTabSettingId : "",
      create: dataImport,
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/table${indicatorsId}/create`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setLoading(false);
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
        setTimeout(function() {
          window.location.href = "/powerbilist";
        }, 3000);
      })
      .catch(function(error) {
        console.log(`${baseUrl}/v1/table${indicatorsId}/create`, error);
        if (error.response.data.message) {
          showNotify(error.response.data.message, "error");
        } else {
          showNotify(error.message, "error");
        }
        setLoading(false);
      });
  };

  // อนุมัติ
  const onApproveTable = (dataImport) => {
    setLoading(true);
    var data = JSON.stringify({
      params: {
        tableHeadId: id,
        indicatorsDatasetSettingId:
          PowerbiData != null ? PowerbiData.indicatorsDatasetSettingId : "",
        tableTabSettingId:
          PowerbiData != null ? PowerbiData.tableTabSettingId : "",
        yearId: PowerbiData != null ? PowerbiData.yearId[0] : "",
      },
      update: {
        status: 1,
      },
    });
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/updatehead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        getCurrentData();
        showNotify("แจ้งเตือน! อนุมัติข้อมูลเรียบร้อย");
      })
      .catch(function(error) {
        console.log(`setting-table/updatehead`, error);
        if (error.response.data.message) {
          showNotify(error.response.data.message, "error");
        } else {
          showNotify(error.message, "error");
        }
        setLoading(false);
      });
  };

  const getCurrentData = () => {
    setLoading(true);
    var data = JSON.stringify({
      params: {
        tableHeadId: id,
        indicatorsDatasetSettingId: indicatorsId,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });
    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          setPowerbiData(response.data.data[0]);
        } else {
          setPowerbiData(null);
          setLoading(false);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(`v1/setting-table/listhead`, error);
      });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 1:
        return <Badge theme="success">ข้อมูลเผยแพร่</Badge>;
      case 2:
        return <Badge theme="danger"> ลบแล้ว</Badge>;
      default:
        return <Badge theme="dark">รอเผยแพร่</Badge>;
    }
  };

  const getMonthName = (no) =>{
    const names=  [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"];
    return names[Number(no)-1];
  }

  useEffect(() => {
    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  return (
    <Layout>
      {loading && <Loading />}
      <ToastContainer />
      <Row>
        <Col md="12">
          <h5 style={{ marginBottom: "30px" }}>จัดการข้อมูลตัวชี้วัด</h5>
        </Col>
      </Row>
      {PowerbiData != null ? (
        <>
          <Row>
            <Col md="12">
              <p style={{ marginBottom: "10px", display: "flex" }}>
                <b style={{ width: 180, textAlign: "right", paddingRight: 15 }}>
                  ข้อมูล/ตัวชี้วัด:{" "}
                </b>
                {PowerbiData.indicatorsDatasetSettingId} -{" "}
                {PowerbiData.indicatorsDatasetSettingName}
              </p>
              <p style={{ marginBottom: "10px", display: "flex" }}>
                <b style={{ width: 180, textAlign: "right", paddingRight: 15 }}>
                  ชุดข้อมูล:{" "}
                </b>
                {PowerbiData.tableTabSettingId} -{" "}
                {PowerbiData.tableTabSettingName}{" "}

                {
                  PowerbiData.indicatorsDatasetSettingId == 20 &&  PowerbiData.list && PowerbiData.list.length > 0 && (
                   <b style={{ paddingLeft: 10 }}> ({PowerbiData.list[0].Import_Export})</b> 
                  )
                }
              </p>
            </Col>
            {PowerbiData.yearNo && (
              <Col md="12">
                <p style={{ marginBottom: "10px", display: "flex" }}>
                  <b
                    style={{ width: 180, textAlign: "right", paddingRight: 15 }}
                  >
                    ปี พ.ศ.:{" "}
                  </b>{" "}
                  {PowerbiData.yearNo}
                  {
                    PowerbiData.indicatorsDatasetSettingId == 20 &&  PowerbiData.list && PowerbiData.list.length > 0 && (
                    <span style={{ paddingLeft: 10 }}>เดือน {getMonthName(PowerbiData.list[0].Month_No)}  </span>
                    )
                  }
                </p>
              </Col>
            )}

            <Col md="12">
              <p style={{ marginBottom: "10px", display: "flex" }}>
                <b style={{ width: 180, textAlign: "right", paddingRight: 15 }}>
                  หน่วยงานเจ้าของข้อมูล:{" "}
                </b>
                {PowerbiData.agencyName}
              </p>
            </Col>
            <Col md="12">
              <p style={{ marginBottom: "10px", display: "flex" }}>
                <b style={{ width: 180, textAlign: "right", paddingRight: 15 }}>
                  ผู้อัพเดทข้อมูล:{" "}
                </b>
                {PowerbiData.firstName} {PowerbiData.lastName}{" "}
                <b style={{ marginLeft: 50, marginRight: 15 }}>
                  {" "}
                  วันที่อัพเดทข้อมูล:{" "}
                </b>{" "}
                {formatDate(PowerbiData.lastUpdate[0])}
              </p>
            </Col>
            <Col md="12">
              <p style={{ marginBottom: "30px", display: "flex" }}>
                <b style={{ width: 180, textAlign: "right", paddingRight: 15 }}>
                  สถานะข้อมูล:{" "}
                </b>
                {getStatusBadge(PowerbiData.status)}
              </p>
            </Col>
          </Row>
          <RowData>
            <KeyinAllTable
              type="edit"
              listheadId={id}
              powerbiDataList={PowerbiData.list}
              tableTabSettingId={PowerbiData.tableTabSettingId}
              indicatorsDatasetSettingId={
                PowerbiData.indicatorsDatasetSettingId
              }
              yearId={PowerbiData.yearId[0]}
              yearNo={PowerbiData.yearNo}
              agencyId={PowerbiData.agencyId[0]}
              status={PowerbiData.status}
              onCeateTable={(sendData) => onCeateTable(sendData)}
              onApproveTable={() => onApproveTable()}
              tableTabMaster={
                tableTabMasterId.indexOf(
                  Number(PowerbiData.tableTabSettingId)
                ) !== -1
              }
            />
          </RowData>
        </>
      ) : (
        <RowData>
          <Col md="12">
            <p style={{ textAlign: "center" }}>
              ไม่มีชุดข้อมูลที่ต้องการเลือกดู
            </p>
          </Col>
        </RowData>
      )}
    </Layout>
  );
};

export default PowerbiSettingDetail;
